import React from 'react';
import { Link } from 'react-router-dom';

const CharacterAppearances = ({ character, animeDetails, handleAnimeClick }) => {
  return (
    <div className="tab-content">
      <div className="left-column">
        {character.anime?.length > 0 && (
          <div className="section">
            <h3>Anime Appearances</h3>
            {character.anime.map((appearance, index) => {
              const animeId = animeDetails[appearance.anime.malId || appearance.anime.mal_id];
              return (
                <AnimeAppearanceCard 
                  key={index}
                  appearance={appearance}
                  animeId={animeId}
                  handleAnimeClick={handleAnimeClick}
                />
              );
            })}
          </div>
        )}

        {character.manga?.length > 0 && (
          <div className="section">
            <h3>Manga Appearances</h3>
            {character.manga.map((appearance, index) => (
              <div key={index} className="character-appearance-card">
                <div className="character-appearance-card-header">
                  <div className="character-appearance-thumbnail">
                    <img src={appearance.manga.images?.webp?.small_image_url || appearance.manga.images?.webp?.smallImageUrl} alt={appearance.manga.title} />
                  </div>
                  <div>
                    <h4>{appearance.manga.title_english || appearance.manga.title}</h4>
                    <p className="text-secondary">Role: {appearance.role}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

const AnimeAppearanceCard = ({ appearance, animeId, handleAnimeClick }) => (
  <Link to={`/anime/${animeId}`}>
  <div 
    className="character-appearance-card"
    onClick={() => animeId && handleAnimeClick(animeId)}
    style={animeId ? { cursor: 'pointer' } : {}}
  >
    <div className="character-appearance-card-header">
      <div className="appearance-thumbnail">
        <img src={appearance.anime.images?.webp?.small_image_url || appearance.anime.images?.webp?.smallImageUrl} alt={appearance.anime.title} />
      </div>
      <div>
        <h4>{appearance.anime.title_english || appearance.anime.title}</h4>
        <p className="text-secondary">Role: {appearance.role}</p>
        <p className="text-secondary" style={{ color: animeId ? '#4a90e2' : '#888' }}>
        </p>
      </div>
    </div>
  </div>
  </Link>
);

export default CharacterAppearances;